import { WizardPage } from '../../components/wizard/types';
import { RnDEmployeeModel } from '../../api/models';
import { FieldModel } from '../../components/form/pageForm/types';

const afiAppGuidanceText: FieldModel<RnDEmployeeModel> = {
    component: 'globalContent',
    label: '',
    name: 'afiAppGuidanceText',
    contentKey: ['AFIAppGuidanceText'],
};

const totalEmployees: FieldModel<RnDEmployeeModel> = {
    component: 'numericInput',
    componentProps: {
        style: {
            maxWidth: '10.5rem',
            textAlign: 'right',
            padding: '1em',
        },
    },
    label: 'Total number of employees',
    name: 'totalEmployees',
    maxLength: 10,
    contentKey: ['ApplicationOrganisationEmployeesTotal'],
};

const rndOnlyEmployees: FieldModel<RnDEmployeeModel> = {
    component: 'numericInput',
    componentProps: {
        style: {
            maxWidth: '10.5rem',
            textAlign: 'right',
            padding: '1em',
        },
    },
    label: 'Number of employees engaged in R&D (person years)',
    name: 'rndOnlyEmployees',
    // 8 numbers, 2 commas, Decimal, 2 places
    maxLength: 13,
    contentKey: ['ApplicationOrganisationEmployeesRDOnly', 'ApplicationOrganisationEmployeesStaff', 'ApplicationOrganisationEmployeesConsolidatedGroups'],
};

const independentContractors: FieldModel<RnDEmployeeModel> = {
    component: 'numericInput',
    componentProps: {
        style: {
            maxWidth: '10.5rem',
            textAlign: 'right',
            padding: '1em',
        },
    },
    label: 'Number of independent contractors engaged in R&D activities',
    name: 'independentContractors',
    // 8 numbers, 2 commas
    maxLength: 10,
    contentKey: ['ApplicationOrganisationIndependentContractors'],
};

const employees: WizardPage<RnDEmployeeModel> = {
    enablingPages: [
        'registrationType',
        'rndEntityDetails',
        'contactDetails',
        'applicationInclusions',
    ],
    apiEndpoint: '/employees',
    name: 'employees',
    title: 'Employees',
    fields: {
        afiAppGuidanceText,
        totalEmployees,
        rndOnlyEmployees,
        independentContractors,
    },
    initialPageValues: {
        totalEmployees: undefined,
        rndOnlyEmployees: undefined,
        independentContractors: undefined,
    },
};

export default employees;
